import style from './RacForm.module.css';
import FormComp from '../../FormComp';

import axios from 'axios';

import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import { FiDownload, FiTrash2 } from 'react-icons/fi';
import {
    AiOutlineFilePdf,
    AiOutlineFileImage,
    AiOutlineFileWord,
    AiOutlineFileExcel,
    AiOutlineFileUnknown,
} from 'react-icons/ai';

import { LuLoaderCircle } from "react-icons/lu";
import { MdOutlineClose } from "react-icons/md";

import { getItensByNorma } from '../../../Funcoes/GetItensByNorma';
import MultiFileUploader from '../../Utils/MultiFileUploader';
import useApi from '../../../hooks/useApi';
import { useToast } from '../../../contexts/ToastContext';

const ConfirmOverlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 100000;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.45);
`;

const ConfirmBox = styled.div`
    width: min(350px, 92%);
    background-color: #fff;
    border-radius: 8px;
    padding: 20px 16px 16px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const ConfirmTitle = styled.p`
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #1f2937;
    text-align: center;
    line-height: 1.4;
`;

const ConfirmActions = styled.div`
    display: flex;
    gap: 10px;
    margin-top: 20px;
    width: 100%;
`;

const ConfirmButton = styled.button`
    flex: 1;
    height: 36px;
    border: none;
    border-radius: 8px;
    font-weight: 700;
    font-size: 12px;
    cursor: pointer;
    background-color: ${(p) => (p.$primary ? '#b91c1c' : '#e5e7eb')};
    color: ${(p) => (p.$primary ? '#fff' : '#1f2937')};

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

const SecaoAnexos = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 8px;
`;

const SemAnexos = styled.p`
    margin: 0;
    font-size: 13px;
    color: #6b7280;
    padding: 10px 12px;
    background-color: #f8fafc;
    border: 1px dashed #cbd5e1;
    border-radius: 8px;
    text-align: center;
`;

const CardAnexo = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    background-color: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    min-width: 0;
`;

const AnexoIconWrap = styled.div`
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    background-color: #fff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
`;

const AnexoInfo = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

const AnexoNome = styled.span`
    font-size: 13px;
    font-weight: 500;
    color: #1e293b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const AnexoTamanho = styled.span`
    font-size: 11px;
    color: #64748b;
`;

const AnexoAcoes = styled.div`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 6px;
`;

const BotaoAnexo = styled.button`
    all: unset;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.15s ease, border-color 0.15s ease;
    color: ${(p) => (p.$danger ? '#b91c1c' : '#1d4ed8')};
    background-color: ${(p) =>
        p.$danger ? 'rgba(185, 28, 28, 0.10)' : 'rgba(29, 78, 216, 0.10)'};
    border: 1px solid transparent;

    &:hover:not(:disabled) {
        background-color: ${(p) =>
            p.$danger ? 'rgba(185, 28, 28, 0.20)' : 'rgba(29, 78, 216, 0.20)'};
        border-color: ${(p) =>
            p.$danger ? 'rgba(185, 28, 28, 0.45)' : 'rgba(29, 78, 216, 0.45)'};
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    &:focus-visible {
        outline: 2px solid ${(p) => (p.$danger ? '#b91c1c' : '#1d4ed8')};
        outline-offset: 2px;
    }
`;

function getFileIcon(filename) {
    const name = String(filename ?? '').toLowerCase();
    if (/\.(png|jpe?g|gif|webp|bmp)$/i.test(name)) {
        return <AiOutlineFileImage size={20} color="#4a90e2" />;
    }
    if (name.endsWith('.pdf')) {
        return <AiOutlineFilePdf size={20} color="#e63946" />;
    }
    if (/\.(doc|docx)$/i.test(name)) {
        return <AiOutlineFileWord size={20} color="#2a6db0" />;
    }
    if (/\.(xls|xlsx)$/i.test(name)) {
        return <AiOutlineFileExcel size={20} color="#207245" />;
    }
    return <AiOutlineFileUnknown size={20} color="#555" />;
}

function formatarTamanho(bytes) {
    if (bytes == null || bytes === '' || Number.isNaN(Number(bytes))) return null;
    const b = Number(bytes);
    if (b < 1024) return `${b} B`;
    if (b < 1024 * 1024) return `${(b / 1024).toFixed(1)} KB`;
    return `${(b / (1024 * 1024)).toFixed(1)} MB`;
}

function normalizeAnexos(anexos) {
    if (!Array.isArray(anexos)) return [];
    return anexos
        .map((item) => {
            if (typeof item === 'string') {
                return { id: null, caminho: item, filename: '', file_size: null };
            }
            return {
                id: item?.id ?? null,
                caminho: item?.caminho ?? '',
                filename: item?.file_name ?? item?.filename ?? '',
                file_size: item?.file_size ?? null,
            };
        })
        .filter((item) => item.caminho);
}

const RacForm = ({ closeForm, updateItens }) => {

    const { id } = useParams();
    const api = useApi();
    const { notifyError, notifySuccess } = useToast();

    const [loading, setLoading] = useState(true)
    const [loadingCount, setLoadingCount] = useState(4)

    const [obras, setObras] = useState([]);
    const [contratos, setContratos] = useState([]);
    const [lideres, setLideres] = useState([]);

    const [formValues, setFormValues] = useState({
        centro_custo: '',
        contrato: '',
        rnc: '',
        tipo: '',
        norma: '',
        item_norma: '',
        setor: '',
        resp_setor: '',
        fato: '',
        evidencia: '',
        correcao: '',
        anal_causa_raiz: '',
        what: '',
        why: '',
        where: '',
        when: '',
        who: '',
        how: '',
        how_much: '',
        data_realizada: '',
        observacoes: '',
        eficacia: '',
        aprovado_por: '',
        data_encerramento: ''
    })

    const [ anexos, setAnexos ] = useState([])
    const [selectedFiles, setSelectedFiles] = useState([])
    const [confirmAnexo, setConfirmAnexo] = useState(null)
    const [deletingAnexo, setDeletingAnexo] = useState(false)

    const setores = [
        "ADM",
        "ALMOXARIFADO/MATERIAIS",
        "ALTA DIREÇÃO",
        "ANDAIMES",
        "COMERCIAL",
        "CONTABILIDADE",
        "CONTROLE DE OBRAS",
        "ELÉTRICA",
        "ENGENHARIA E ORÇAMENTOS",
        "FABRICAÇÃO (PIPE SHOP)",
        "FINANCEIRO",
        "FISCAL",
        "IÇAMENTO E MOVIMENTAÇÃO DE CARGA",
        "INSTRUMENTAÇÃO",
        "ISOLAMENTO TÉRMICO",
        "JURÍDICO",
        "LOGÍSTICA",
        "MANUTENÇÃO MECÂNICA",
        "MECÂNICA",
        "PINTURA",
        "PLANEJAMENTO/GERENCIAMENTO DE OBRAS",
        "QUALIDADE",
        "RECURSOS HUMANOS",
        "SGI - SISTEMA DE GESTÃO INTEGRADO",
        "SSMA",
        "SUPRIMENTOS",
        "T.I.",
        "TUBULAÇÃO"
    ]

    const decreaseLoading = () => {

        setLoadingCount(prev => {

            if (prev > 0) {

                const newCount = prev - 1;
                if (newCount === 0) setLoading(false);
                return newCount;

            } else {

                return 0

            }

        })

    }

    useEffect(() => {

        if (id) {

            const getValues = async () => {

                try {

                    const { data } = await api.post('/Painel/API/RAC/GetRegister/index.php?id=' + id)

                    setFormValues(prev => ({

                        ...prev,
                        centro_custo: data.centro_custo || '',
                        contrato: data.contrato || '',
                        rnc: data.rnc || '',
                        tipo: data.tipo_nc || '',
                        norma: data.norma || '',
                        item_norma: data.item_norma || '',
                        setor: data.setor || '',
                        resp_setor: data.responsavel_setor || '',
                        fato: data.fato || '',
                        evidencia: data.evidencia || '',
                        correcao: data.correcao || '',
                        anal_causa_raiz: data.anal_causa_raiz || '',
                        what: data.what || '',
                        why: data.why || '',
                        where: data.where || '',
                        when: data.when || '',
                        who: data.who || '',
                        how: data.how || '',
                        how_much: data.how_much || '',
                        data_realizada: data.realizado || '',
                        observacoes: data.observacoes || '',
                        eficacia: data.eficaz || '',
                        aprovado_por: data.aprovado || '',
                        data_encerramento: data.encerramento || ''
                    }))

                    setAnexos(normalizeAnexos(data.anexos))

                } catch (error) {

                    console.log(error)

                } finally {

                    decreaseLoading();

                }

            }

            getValues();

        } else {

            decreaseLoading();

        }

    }, [])

    useEffect(() => {

        const getObras = async () => {

            try {

                const { data } = await axios.get("https://sistemaintegrado.palmont.com.br/Painel/API/GetObrasAtivas/")
                setObras(data.map(obj => obj.OBRA))

            } catch (error) {

                console.log(error)

            } finally {

                decreaseLoading();

            }

        }

        getObras();

    }, [id])

    useEffect(() => {

        const getContratos = async () => {

            try {

                const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/GetContratosObra/', {
                    centro_custo: formValues.centro_custo
                })

                setContratos(data.map(obj => obj.nome_contrato))

            } catch (error) {

                console.log(error)

            } finally {

                decreaseLoading();

            }

        }

        getContratos();

    }, [id, formValues.centro_custo])

    useEffect(() => {

        const getLideres = async () => {

            try {

                const { data } = await axios.get('https://sistemaintegrado.palmont.com.br/Painel/assets/php/getLideres.php')
                setLideres(data.map(obj => obj.RA_NOMECMP))

            } catch (error) {

                console.error(error)

            } finally {

                decreaseLoading();

            }

        }

        getLideres();

    }, [])

    const handleChange = (field, e) => {

        let { value } = e.target;

        if (field === "how_much") {
            value = value.replace(/\D/g, ""); // Remove tudo que não for número
            value = value ? parseInt(value, 10) : 0; // Converte para inteiro (centavos)
            value = (value / 100).toFixed(2); // Formata para decimal
        }

        setFormValues(prev => ({
            ...prev,
            [field]: value,
            ...(field === "centro_custo" && { contrato: "" }),
            ...(field === "norma" && { item_norma: "" }),
        }));
    };


    const handleSubmit = async (e) => {

        e.preventDefault();

        const formData = new FormData();
        for (const key in formValues) {

            formData.append(key, formValues[key]);

        }

        if (selectedFiles?.length) {
            selectedFiles.forEach((item) => {
                formData.append('files[]', item.file);
            });
        }

        try {

            const url = id
                ? "https://sistemaintegrado.palmont.com.br/Painel/API/RAC/UpdateItem/index.php?id=" + id
                : "https://sistemaintegrado.palmont.com.br/Painel/API/RAC/SaveItem/"

            const method = 'post'

            const { data } = await toast.promise(
                axios({
                    method: method,
                    url: url,
                    data: formData,
                    headers: {
                        withCredentials: true,
                        'Content-Type': 'multipart/form-data'
                    }
                }),
                {
                    pending: 'SALVANDO INFORMAÇÕES',
                    success: 'INFORMAÇÕES SALVAS COM SUCESSO',
                    error: 'FALHA AO SALVAR AS INFORMAÇÕES'
                }
            )

            console.log(data);
            await updateItens();
            closeForm();

        } catch (error) {

            console.log(error);

        }

    }

    const getFileName = (anexo) => {
        if (anexo?.filename) return anexo.filename;
        const path = anexo?.caminho ?? '';
        return path.split('/').pop() || 'arquivo';
    };

    const openDeleteConfirm = (anexo) => {
        if (!anexo?.id) return;
        setConfirmAnexo(anexo);
    };

    const handleCancelDeleteAnexo = () => {
        if (deletingAnexo) return;
        setConfirmAnexo(null);
    };

    const handleConfirmDeleteAnexo = async () => {
        if (!confirmAnexo?.id || deletingAnexo) return;

        setDeletingAnexo(true);

        try {
            await api.post('/Painel/API/RAC/DeleteAnexo/index.php', {
                id: confirmAnexo.id,
            });

            setAnexos((prev) =>
                normalizeAnexos(prev).filter((anexo) => anexo.id !== confirmAnexo.id)
            );

            notifySuccess('Anexo removido com sucesso.');
            setConfirmAnexo(null);

            if (typeof updateItens === 'function') {
                await updateItens();
            }
        } catch (error) {
            const msg = error.response?.data?.message ?? 'Erro ao remover anexo.';
            notifyError(msg);
        } finally {
            setDeletingAnexo(false);
        }
    };

    return (
        <div className={style.container} >
            <div className={style.header} >
                {id ?
                    <p className={style.tituloForm} >EDITANDO ID {id}</p>
                    :
                    <p className={style.tituloForm} >GERANDO NOVA RAC</p>
                }
                <div
                    className={style.closeDiv}
                    onClick={closeForm}
                >
                    <MdOutlineClose className={ style.closeIcon } />
                </div>
            </div>

            {
                loading ?
                    <div className={style.loading} >
                        <div className={ style.loadingContainer } >
                            <div className={style.spinnerContainer} >
                                <LuLoaderCircle className={ style.spinner } />
                            </div>
                            <p>CARREGANDO...</p>
                        </div>
                    </div>
                    :
                    <div className={style.body} >
                        <form
                            onSubmit={handleSubmit}
                        >
                            <FormComp
                                title="CENTRO CUSTO"
                                type="select"
                                options={obras}
                                valor={formValues.centro_custo}
                                changeFunc={(e) => handleChange('centro_custo', e)}
                            />
                            <FormComp
                                title="CONTRATO"
                                type="select"
                                options={contratos}
                                valor={formValues.contrato}
                                changeFunc={(e) => handleChange('contrato', e)}
                            />
                            <FormComp
                                title="RNC"
                                type="text"
                                valor={formValues.rnc}
                                changeFunc={(e) => handleChange('rnc', e)}
                            />
                            <FormComp
                                title="TIPO"
                                type="select"
                                options={[
                                    "NC RECLAMAÇÃO DO CLIENTE",
                                    "NC INTERNA",
                                    "NC FORNECEDOR",
                                    "NC AUDITORIA EXTERNA ( CERTIFICADORA )",
                                    "NC AUDITORIA EXTERNA ( CLIENTES )",
                                    "RISCOS E OPORTUNIDADES"
                                ]}
                                valor={formValues.tipo}
                                changeFunc={(e) => handleChange('tipo', e)}
                            />
                            <FormComp
                                title="NORMA"
                                type="select"
                                options={[
                                    "ISO 9001:2015",
                                    "ISO 14001:2015",
                                    "ISO 45001:2018"
                                ]}
                                valor={formValues.norma}
                                changeFunc={(e) => handleChange('norma', e)}
                            />
                            <FormComp
                                title="ITEM"
                                type="select"
                                options={
                                    getItensByNorma(formValues.norma)
                                }
                                valor={formValues.item_norma}
                                changeFunc={(e) => handleChange('item_norma', e)}
                            />
                            <FormComp
                                title="SETOR"
                                type="select"
                                options={setores}
                                valor={formValues.setor}
                                changeFunc={(e) => handleChange('setor', e)}
                            />
                            <FormComp
                                title="RESPONSÁVEL PELO SETOR"
                                type="select"
                                options={lideres}
                                valor={formValues.resp_setor}
                                changeFunc={(e) => handleChange('resp_setor', e)}
                            />
                            <FormComp
                                title="FATO"
                                type="textarea"
                                valor={formValues.fato}
                                changeFunc={(e) => handleChange('fato', e)}
                            />
                            <FormComp
                                title="EVIDÊNCIA OBJETIVA"
                                type="textarea"
                                valor={formValues.evidencia}
                                changeFunc={(e) => handleChange('evidencia', e)}
                            />
                            <FormComp
                                title="CORREÇÃO IMEDIATA"
                                type="textarea"
                                valor={formValues.correcao}
                                changeFunc={(e) => handleChange('correcao', e)}
                                titleHover="OQUE É FEITO PARA RESOLVER ESSE PROBLEMA"
                            />
                            <FormComp
                                title="ANÁLISE DA CAUSA RAIZ"
                                type="textarea"
                                valor={formValues.anal_causa_raiz}
                                changeFunc={(e) => handleChange('anal_causa_raiz', e)}
                                titleHover="OQUE FALHOU NO SISTEMA PARA PERMITIR QUE ESSA NC OCORRA"
                            />
                            <FormComp
                                title="AÇÃO CORRETIVA - WHAT ( O QUE SERÁ FEITO ? )"
                                type="textarea"
                                valor={formValues.what}
                                changeFunc={(e) => handleChange('what', e)}
                                titleHover="OQUE É FEITO PARA EVITAR A RECORRÊNCIA"
                            />
                            <FormComp
                                title="WHY ( POR QUE SERÁ FEITO ? )"
                                type="textarea"
                                valor={formValues.why}
                                changeFunc={(e) => handleChange('why', e)}
                            />
                            <FormComp
                                title="WHERE ( ONDE SERÁ FEITO ? )"
                                type="textarea"
                                valor={formValues.where}
                                changeFunc={(e) => handleChange('where', e)}
                            />
                            <FormComp
                                title="WHEN ( QUANDO SERÁ FEITO ? )"
                                type="date"
                                valor={formValues.when}
                                changeFunc={(e) => handleChange('when', e)}
                            />
                            <FormComp
                                title="WHO ( POR QUEM SERÁ FEITO ? )"
                                type="select"
                                options={lideres}
                                valor={formValues.who}
                                changeFunc={(e) => handleChange('who', e)}
                            />
                            <FormComp
                                title="HOW ( COMO SERÁ FEITO ? )"
                                type="textarea"
                                valor={formValues.how}
                                changeFunc={(e) => handleChange('how', e)}
                            />
                            <FormComp
                                title="HOW MUCH ( QUANTO VAI CUSTAR ? )"
                                type="number"
                                valor={formValues.how_much}
                                changeFunc={(e) => handleChange('how_much', e)}
                            />
                            <FormComp
                                title="DATA REALIZADA"
                                type="date"
                                valor={formValues.data_realizada}
                                changeFunc={(e) => handleChange('data_realizada', e)}
                            />
                            {id && (
                                <SecaoAnexos>
                                    <p className={style.anexosTitle}>ANEXOS</p>
                                    {anexos.length >= 1 ? (
                                        anexos.map((anexo) => {
                                            const nome = getFileName(anexo);
                                            const tamanho = formatarTamanho(anexo.file_size);
                                            return (
                                                <CardAnexo key={anexo.id ?? anexo.caminho}>
                                                    <AnexoIconWrap>
                                                        {getFileIcon(nome)}
                                                    </AnexoIconWrap>
                                                    <AnexoInfo>
                                                        <AnexoNome title={nome}>{nome}</AnexoNome>
                                                        {tamanho && <AnexoTamanho>{tamanho}</AnexoTamanho>}
                                                    </AnexoInfo>
                                                    <AnexoAcoes>
                                                        <BotaoAnexo
                                                            as="a"
                                                            href={anexo.caminho}
                                                            download
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            title="Baixar anexo"
                                                        >
                                                            <FiDownload size={14} />
                                                        </BotaoAnexo>
                                                        <BotaoAnexo
                                                            type="button"
                                                            $danger
                                                            title="Excluir anexo"
                                                            disabled={!anexo.id || deletingAnexo}
                                                            onClick={() => openDeleteConfirm(anexo)}
                                                        >
                                                            <FiTrash2 size={14} />
                                                        </BotaoAnexo>
                                                    </AnexoAcoes>
                                                </CardAnexo>
                                            );
                                        })
                                    ) : (
                                        <SemAnexos>Nenhum anexo.</SemAnexos>
                                    )}
                                </SecaoAnexos>
                            )}

                            <p className={style.anexosTitle}>
                                {id ? 'ADICIONAR ANEXOS' : 'ANEXOS'}
                            </p>
                            <MultiFileUploader
                                files={selectedFiles}
                                setFiles={setSelectedFiles}
                                accept="*"
                                maxFiles={0}
                            />
                            <FormComp
                                title="OBSERVAÇÕES"
                                type="textarea"
                                valor={formValues.observacoes}
                                changeFunc={(e) => handleChange('observacoes', e)}
                            />
                            <FormComp
                                title="EFICÁCIA DAS AÇÕES"
                                type="select"
                                options={["SIM"]}
                                valor={formValues.eficacia}
                                changeFunc={(e) => handleChange('eficacia', e)}
                            />
                            <FormComp
                                title="APROVADO POR"
                                type="select"
                                options={lideres}
                                valor={formValues.aprovado_por}
                                changeFunc={(e) => handleChange('aprovado_por', e)}
                            />
                            <FormComp
                                title="DATA DE ENCERRAMENTO"
                                type="date"
                                valor={formValues.data_encerramento}
                                changeFunc={(e) => handleChange('data_encerramento', e)}
                            />
                            <FormComp
                                type="submit"
                                valor="SALVAR"
                            />
                        </form>
                    </div>
            }

            {confirmAnexo && (
                <ConfirmOverlay
                    onClick={(e) => {
                        e.stopPropagation();
                        if (e.target === e.currentTarget) {
                            handleCancelDeleteAnexo();
                        }
                    }}
                >
                    <ConfirmBox onClick={(e) => e.stopPropagation()}>
                        <ConfirmTitle>
                            Deseja excluir o arquivo &quot;{getFileName(confirmAnexo)}&quot;?
                        </ConfirmTitle>
                        <ConfirmActions>
                            <ConfirmButton
                                type="button"
                                onClick={handleCancelDeleteAnexo}
                                disabled={deletingAnexo}
                            >
                                NÃO
                            </ConfirmButton>
                            <ConfirmButton
                                type="button"
                                $primary
                                onClick={handleConfirmDeleteAnexo}
                                disabled={deletingAnexo}
                            >
                                {deletingAnexo ? 'EXCLUINDO…' : 'SIM'}
                            </ConfirmButton>
                        </ConfirmActions>
                    </ConfirmBox>
                </ConfirmOverlay>
            )}
        </div>
    )

}

export default RacForm;